import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=423126e6&scoped=true"
var script = {}
import style0 from "./Action.vue?vue&type=style&index=0&id=423126e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423126e6",
  null
  
)

export default component.exports